interface IconProps {
  color?: string;
}
const NawyNowFilterIcon = ({ color }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        d="M20 7.8125H11M14 17.8125H5M14 17.8125C14 19.4694 15.3431 20.8125 17 20.8125C18.6569 20.8125 20 19.4694 20 17.8125C20 16.1556 18.6569 14.8125 17 14.8125C15.3431 14.8125 14 16.1556 14 17.8125ZM10 7.8125C10 9.46935 8.65685 10.8125 7 10.8125C5.34315 10.8125 4 9.46935 4 7.8125C4 6.15565 5.34315 4.8125 7 4.8125C8.65685 4.8125 10 6.15565 10 7.8125Z"
        stroke="#015C9A"
        stroke-width="1.6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default NawyNowFilterIcon;
